<template>
  <div>
    <v-btn class="mt-4" @click.native="printOverallIncome">
      <v-icon>print</v-icon>
    </v-btn>
    <v-switch
        v-model="hideZero"
        inset
        class="mb-2"
        label="Major Incomes"
      />
      <v-spacer/>
    <v-data-table :items="list" class="elevation-1 black--text font-weight-bold"  :headers="headers">
      <template slot="items" slot-scope="props">
        <!-- <td>{{ props.item['.key'] }}</td> -->
        <!-- <td>{{ props.item.firm }}</td> -->
        <td><b class="primary--text font-weight-bolder">{{ props.item.income }}</b></td>
        <td>{{ props.item.category}}</td>
        <td>{{ props.item.underHead }}</td>
        <!-- <td>{{ props.item.totalAmount || 0 | amount }}</td> -->
        <td>{{ props.item.openingBalance | amount }}</td>
        <td>{{ props.item.totalAmount | amount }}</td>
        <td> <b class="primary--text font-weight-bolder"> {{ ((props.item.openingBalance ? Number.parseFloat(props.item.openingBalance) : 0 ) + (props.item.totalAmount ? Number.parseFloat(props.item.totalAmount) : 0)) | amount }}</b></td>
        <td>{{ props.item.paymentTypeStatus }}</td>
        <td><v-btn icon round class="primary--text" @click="openIncomeDialog(props.item)">
          <v-icon dark>
            remove_red_eye
          </v-icon>
        </v-btn>
        </td>
        <td><v-btn icon round class="primary--text" @click="openIncomeEdit(props.item)">
          <v-icon dark> 
            edit 
          </v-icon>
        </v-btn></td>
        <!-- <td>{{ props.item.depriciation ? `${props.item.depriciation}%` : '--' }}</td> -->
        <!-- { text: 'Opening WDV', value: 'openingBalance', sortable: false}, -->
        <!-- { text: 'Addition', value: 'additionAmount', sortable: false}, -->
        <!-- { text: 'Deletion', value: 'deletionAmount', sortable: false}, -->
        <!-- <td>{{ props.item.totalDeletionAmount | amount }}</td> -->
        <!-- { text: 'Total', value: 'totalAmount', sortable: false}, -->
        <!-- { text: 'Dep Amount (Business)', sortable: false}, -->
        <!-- <td>{{ getDepAmount(props.item, props.item.category) | amount }}</td> -->
        <!-- { text: 'Closing WDV', sortable: false} -->
      </template>
      <template slot="no-data">No Incomes to Show</template>
    </v-data-table>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ selectedIncome }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table :items="selectedIncomes" class="elevation-1 black--text font-weight-bold"  :headers="incomeHeader">
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item['.key'] }}</td> -->
          <td><b class="primary--text font-weight-bold">{{ getFirmName(props.item.firm) }}</b></td>
          <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td>
          <td>{{ props.item.openingBalance || 0 | amount }}</td>
          <td><b class="success--text font-weight-bolder">{{ props.item.totalAmount || 0 | amount }}</b></td>
          <!-- <td>{{ getTotalAmount(props.item)|| 0 | amount }}</td> -->
          <td>
            <b class="primary--text font-weight-bolder">
              {{ (Number.parseFloat(props.item.openingBalance ?  props.item.openingBalance : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0| amount }}
            </b>
          </td>
          <td>{{ props.item.paymentType }}</td>
          <td>{{ props.item.remark}}</td>
          <td><v-btn v-if=" props.item.paymentTypeStatus == 'yet to confirm'" @click="openIncomeInvoiceEdit(props.item,true)">{{ props.item.paymentTypeStatus }}</v-btn>
              <b v-else>{{ props.item.paymentTypeStatus }}</b>
          </td>
          <td>
            <v-btn icon class="primary--text" @click="openIncomeInvoiceEdit(props.item,false)">
              <v-icon dark>
                edit
              </v-icon>  
            </v-btn>
          </td>
          <td>
            <v-btn icon class="red--text" @click="openIncomeInvoiceDelete(props.item)">
              <v-icon dark>
                delete
              </v-icon>  
            </v-btn>
          </td>
        </template>
        <template slot="no-data">no record found</template>
      </v-data-table>
    </v-dialog>
    <v-dialog v-model="dialogEdit" transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title v-if="selectedIncome">{{ selectedIncome.income }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialogEdit = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <v-card tile v-if="selectedIncome">
          <v-card-text>
            <v-text-field 
                label="Name" 
                v-model="selectedIncome.income">
            </v-text-field>
          <v-select
                v-bind:items="categotyList"
                v-model="selectedIncome.category" 
                label="income Category"
            />
            <v-select 
                v-bind:items="underHeadList"
                v-model="selectedIncome.underHead" 
                label="UnderHead"
            />
             <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveIncome()">Save</v-btn>
          </v-card-actions>
            </v-card-text>
          </v-card>

    </v-dialog>
     <v-dialog v-model="dialogEditInvoice" transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title v-if="isConfirm">Confirm Income</v-toolbar-title>
            <v-toolbar-title v-else>Edit Income</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialogEditInvoice = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <v-card tile v-if="selectedIncomeInvoice" >
          <v-card-text>
              <v-radio-group v-model="selectedIncomeInvoice.paymentType" row>
                  <v-radio label="From Cash" value="cash"></v-radio>
                  <v-radio label="From Bank Account" value="account"></v-radio>
              </v-radio-group>
              <v-menu
                v-model="datepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
                <v-text-field
                  slot="activator"
                  v-model="selectedIncomeInvoice.date"
                  label="Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker 
                  v-model="selectedIncomeInvoice.date"
                  @input="datepicker = false"
                />
            </v-menu>
             <v-select
              class="select-firm"
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedIncomeInvoice.firm"
            ></v-select>
              <v-select 
            v-if="selectedIncomeInvoice.paymentType == 'account'" 
                v-model="selectAccountFromIncome"
                :items="banksByFirm"
                label="From Account"
                :disabled="!selectedIncomeInvoice.firm"
                required
            >
                <template slot="selection" slot-scope="data">
                    {{ data.item.accountnumber }}{{data.item.bankName ? ' | '+data.item.bankName : '' }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.accountnumber}
                            ${data.item.bankName ? ' | '+data.item.bankName : '' }
                            ${data.item.accountType ? ' | '+data.item.accountType : '' }`
                        " />
                    </v-list-tile-content>
                </template>
            </v-select>
             <v-text-field
                type="number"
                v-model="selectedIncomeInvoice.openingBalance"
                label="Opening Balance"
              ></v-text-field>
              <v-text-field
                :value="selectedIncome"
                label="Income"
                v-if="isConfirm"
                :disabled="true"
              ></v-text-field>
              <v-text-field
                type="number"
                v-model="selectedIncomeInvoice.totalAmount"
                label="Amount"
              ></v-text-field>
            
               <v-text-field
                v-model="selectedIncomeInvoice.remark"
                label="Remark"
              ></v-text-field>
             <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
                color="primary" 
                @click="saveIncomeInvoice()">
                <span v-if="isConfirm">Confirm</span>
                <span v-else>Save</span>
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { incomeOverallReport } from "../../../utils/pdf-reports/incomeOverallReport.js";

export default {
  name: "incomeTableInfo",
  props: {
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array },
    },
  created() {
    this.$bindAsArray("incomes", this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('banks', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear"]),
        banksByFirm(){
        return this.banks.filter((item) =>
        item['brand'] === this.selectedBrand 
          && item['firm'] == this.selectedIncomeInvoice.firm
        )
    },
    list() {
        let incomes = this.incomes.filter(income => income.brand === this.selectedBrand);
        incomes = incomes.filter(income => !!income['.key']);
        incomes.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key']
          && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end))
          console.log(invoices)
          invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          incomes[index].paymentTypeStatus = paymentTypeStatus;
          incomes[index].totalAmount = isNaN(totalAmount) ? 0 :   Number.parseFloat(totalAmount).toFixed(2);
          incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
        })
      return incomes.filter((e) => {
        if (this.hideZero) {
          return parseFloat(e.totalAmount) > 0 || parseFloat(e.openingBalance) > 0;
        }
        return true;
      });
    },
  },
  data() {
    return {
      selectedIncome : [],
      selectedIncomeInvoice : {},
      isConfirm : false,
      datepicker : false,
      selectAccountFromIncome:null,
      headers: [
        // { text: "Id", value: ".key", sortable: false },
        { text: "Name", value: "income", sortable: true },
        { text: "Category", value: "category", sortable: true },
        { text: "Underhead", value: "underHead", sortable: false },
        { text: "Opening WDV", value: "openingBalance", sortable: false },
        { text: "Amount", value: "totalAmount", sortable: false },
        { text: "Closing WDV", sortable: false },
        { text: "Status", value: "paymentTypeStatus", sortable: false },
        { text: "Action", sortable: false },
        { text: "Edit", sortable: false },
        // { text: "Addition", value: "additionAmount", sortable: false },
        // { text: "Deletion", value: "deletionAmount", sortable: false },
        // { text: "Dep Amount", sortable: false },
      ],
      incomeHeader: [
        // { text: "Id", value: ".key", sortable: false },
        { text: "Firm Name", value: "firm", sortable: true },
        { text: "Date", value: "date", sortable: true },
        { text: "Opening WDV", value: "openingBalance", sortable: false },
        { text: "Amount", value: "totalAmount", sortable: false },
        { text: "Closing WDV", sortable: false },
        { text: "Payment Type", value: "paymentType", sortable: false },
        { text: "Remark", value: "type", sortable: false },
        { text: "Status", value: "paymentTypeStatus", sortable: false },
        { text: "Edit", sortable: false },
        { text: "Delete", sortable: false },
      ],
      dialog : false,
      dialogEdit : false,
      dialogEditInvoice: false,
      categotyList: ['Direct', 'Indirect'],
      underHeadList: ['Prop Capital A/C', 'Profit and Loss'],
      selectedIncomes :[],
    };
  },
  methods: {
    // getDepAmount(income, type) {
    //   let depriciation = null;
    //   if (income.isVerified && income.depriciation) {
    //     const totalAmount = this.getTotalAmount(income);
    //     depriciation = Number((totalAmount * income.depriciation) / 100);
    //     return depriciation;
    //   }
    //   return 0;
    // },
    async printOverallIncome(income){
      let firm  =this.firms.filter(item => item['.key'] === income['firm'])[0];
      await incomeOverallReport({
        // school: this.schools.filter((item) => item.id == this.defaultSchool)[0],
        firm : this.firm,        
        list : this.list,
      }).then((doc) => {
        pdfMake.createPdf(doc).download('INCOME_REPORT_' + new Date ().toLocaleDateString('en-GB'));
      });
    },  
    getTotalAmount(income) {
        return (
          Number(income.totalamount)
        );
    },
    getClosingWdv(income) {
      return (
        this.getTotalAmount(income)
      );
    },
    saveIncome() {
      let key = this.selectedIncome['.key'];
      delete  this.selectedIncome['.key'];
      this.$root.$firebaseRefs.incomes.child(key).update(this.selectedIncome).then((snap) => {
        this.dialogEdit = false;
      });
    },
    saveIncomeInvoice(){
      this.selectedIncomeInvoice.date = new Date(this.selectedIncomeInvoice.date).getTime()
          if(this.selectedIncomeInvoice.paymentType == 'cash' && this.isConfirm){
              this.$root.$firebaseRefs.firm.child(this.selectedIncomeInvoice.firm).once('value').then((snap) => {
                  if(Number(snap.val().amount) >= this.selectedIncomeInvoice.totalAmount){
                      this.$root.$firebaseRefs.firm.child(this.selectedIncomeInvoice.firm).update({
                          amount: Number(snap.val().amount) + Number(this.selectedIncomeInvoice.totalAmount)
                      });
                      setTimeout(() => {
                        let key = this.selectedIncomeInvoice['.key'];
                        delete this.selectedIncomeInvoice['.key'];
                        this.selectedIncomeInvoice['paymentTypeStatus'] = 'confirm';
                        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedIncomeInvoice, ()=>{
                          this.selectedIncomeInvoice.isCredited = false;
                          this.$root.$firebaseRefs.provisionIncome.push(this.selectedIncomeInvoice)
                          this.dialogEditInvoice = false;
                        })
                        
                      })
                  } else{
                      console.log('Insufficient Balance')      
                  }
              })
          } else if(this.selectedIncomeInvoice.paymentType == 'account' && this.isConfirm) {
              let incomeAccountFirm= null;
              let incomeAccountNumber =null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromIncome['.key']).once('value').then(snap => {
                  this.selectedIncomeInvoice['accountNumber'] =  snap.val().accountnumber;
                  this.selectedIncomeInvoice['bank'] =  this.selectAccountFromIncome['.key'];
                  if(Number(snap.val().amount) >= this.selectedIncomeInvoice.totalAmount){
                    this.$root.$firebaseRefs.account.child(this.selectAccountFromIncome['.key']).update({
                      amount: Number(snap.val().amount) + Number(this.selectedIncomeInvoice.totalAmount)
                    });
                      console.log( "income amount paid");
                       setTimeout(() => {
                        let key = this.selectedIncomeInvoice['.key'];
                        delete this.selectedIncomeInvoice['.key'] 
                        this.selectedIncomeInvoice['paymentTypeStatus'] = 'confirm';
                        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedIncomeInvoice, ()=>{
                          this.selectedIncomeInvoice.isCredited = false;
                          this.$root.$firebaseRefs.provisionIncome.push(this.selectedIncomeInvoice)
                          this.dialogEditInvoice = false;
                        })
                      })
                  } else{
                      console.log('Insufficient Balance');
                  }
              })
          } else {
            let key = this.selectedIncomeInvoice['.key'];
            delete this.selectedIncomeInvoice['.key'] 
            this.$root.$firebaseRefs.invoice.child(key).update(this.selectedIncomeInvoice).then((snap) => {
                this.selectedIncomeInvoice['.key'] = key;
                this.dialogEditInvoice = false;
            });
          }
    },
    openIncomeDialog(income) {
      if(income) {
          let invoice = this.invoices.filter(invoice => {
          return (
            invoice.brand === this.selectedBrand &&
            invoice.transactionType === "income" &&
            invoice.incomeType == income[".key"] && 
            (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end)
          );
        });
        invoice.sort(function(a,b){
          return -(new Date(b.date) - new Date(a.date));
        });
        this.selectedIncomes = invoice;
        this.selectedIncome = income["income"];
        this.dialog = true;
      }
    },
    openIncomeEdit(income) {
      this.selectedIncome = income
      this.dialogEdit = true;
    },
     openIncomeInvoiceEdit(invoice,confirmDialog) {
      this.selectedIncomeInvoice = invoice;
      this.selectedIncomeInvoice.date = new Date(this.selectedIncomeInvoice.date).toISOString().substr(0, 10)
      this.dialogEditInvoice = true;
      this.isConfirm = confirmDialog;
    },
    openIncomeInvoiceDelete(selectedIncomeInvoice) {
      if (window.confirm("Do you want to delete income created on "  + new Date (selectedIncomeInvoice['date']).toLocaleDateString('en-GB') + "?")) {
        this.$root.$firebaseRefs.invoice.child(selectedIncomeInvoice[".key"]).remove();
      }
    },
    getFirmName(e){
      let firm;
        if(this.firms && this.selectedBrand) {
          firm =this.firms.filter(item => item['.key'] === e)[0]
        }
        if(firm)
          return firm.name
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InvoiceManagement/table/incomeTable.vue